import angular from 'angular';
import DocumentService from '@/shared/services/DocumentService';
import moment from 'moment';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import { isDutchTenantConfiguration } from '@/shared/TenantConfigurationConstants';
import dataCacheService from '@/shared/services/DataCacheService';
import { ConnectPlatform } from '@/shared/connectPlatformConstants';
import AuthService from '@/shared/services/AuthService';
import { getZendeskUrl } from '@/shared/components/ZendeskHelp';
import { languageSorterCurrentFirst } from '@/shared/utils/sorters';

const SessionStorageKey = 'InvoiceTemplatesSettings';
const CollapsedStorageKey = 'cx-invoice-template-examples-collapsed';
export const invoiceTemplateTypes = [0, 1, 2, 11, 12, 14, 15, 16, 17, 25];
const invoiceTemplateTypesFallbacks = { 11: 0, 12: 0, 14: 0, 15: 0, 16: 0, 25: 0, 17: 2 };

angular
  .module('cxSettings')
  .controller('InvoiceTemplatesCtrl', [
    'flySvc',
    'ModalService',
    '$http',
    'appUrls',
    'Blob',
    'FileSaver',
    'dialogsSvc',
    'enumCacheSvc',
    'checkFeature',
    '$window',
    '$translate',
    '$timeout',
    'localStorageService',
    'dataCache',
    '$rootScope',
    '$scope',
    'translateListFilter',
    invoiceTemplatesCtrl,
  ]);

function invoiceTemplatesCtrl(
  flySvc,
  ModalService,
  $http,
  appUrls,
  Blob,
  FileSaver,
  dialogsSvc,
  enumCacheSvc,
  checkFeature,
  $window,
  $translate,
  $timeout,
  localStorageService,
  dataCache,
  $rootScope,
  $scope,
  translateListFilter,
) {
  var vm = this;
  vm.invoiceTemplates = [];
  vm.templateTypes = [];
  vm.exampleTemplatesCollapsed = false;
  vm.companyTemplateOverviewCollapsed = true;
  vm.company = null;
  vm.languageCode = null;
  vm.languages = dataCache.getArray('language');
  vm.templateType = null;
  vm.activeOnly = false;
  vm.companies = dataCache.getAllCompanies().sort(dynamicSort('name'));
  vm.multipleCompanies = vm.companies.length > 1;
  vm.showCompanyColumn = vm.multipleCompanies;
  vm.showEditTemplate = false;
  vm.templateCheckoutInfo = null;
  vm.HasO365EditorEnabled = dataCacheService.hasUserConnectPlatform(ConnectPlatform.O365Editor);
  vm.ArticleNumber = isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
    ? '23983973904668'
    : '23450504415388';
  // TODO: this info should be stored somewhere on a central location
  // These are the default templates, that are seeded into the tenants, but they should also be available to download at any time
  // The documentId corresponds to the filename of the document in storage\00000-0000\document-templates\
  vm.sampleTemplates = [
    {
      templateType: 0,
      name: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? 'Factuur, met factuurregels'
        : 'Factuur, met factuurlijnen',
      languageCode: 'nl',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '1BCD8B0C-4418-FA2B-6F3C-D84FE12FA1D2'
        : '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1D2',
    },
    {
      templateType: 0,
      name: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? 'Factuur, met factuurregels (gegroepeerd op omschrijving)'
        : 'Factuur, met factuurlijnen (gegroepeerd op omschrijving)',
      languageCode: 'nl',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '8ADB8306-6143-FA2B-6F3C-000D3A1125E9'
        : '8ADB8306-6143-11EB-6F3C-000D3A1125E9',
    },
    {
      templateType: 0,
      name: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? 'Factuur, zonder factuurregels. Enkel omschrijving en totaal'
        : 'Factuur, zonder factuurlijnen. Enkel omschrijving en totaal',
      languageCode: 'nl',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '1BCD8B0C-4418-FA2B-6F3C-D84FE12FA1D1'
        : '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1D1',
    },
    {
      templateType: 0,
      name: 'Facture, avec lignes de facture',
      languageCode: 'fr',
      documentId: '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1E2',
    },
    {
      templateType: 0,
      name: 'Facture, avec lignes de facture (regroupées par description)',
      languageCode: 'fr',
      documentId: '8ADB8305-6143-11EB-6F3C-000D3A1125E9',
    },
    {
      templateType: 0,
      name: 'Facture, sans lignes de facture. Seulement description et total',
      languageCode: 'fr',
      documentId: '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1E1',
    },
    {
      templateType: 0,
      name: 'Invoice, with invoice lines',
      languageCode: 'en',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '1BCD8B0C-4418-FA2B-6F3C-D84FE12FA1C2'
        : '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1C2',
    },
    {
      templateType: 0,
      name: 'Invoice, with invoice lines (grouped by description)',
      languageCode: 'en',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '8ADB8307-6143-FA2B-6F3C-000D3A1125E9'
        : '8ADB8307-6143-11EB-6F3C-000D3A1125E9',
    },
    {
      templateType: 0,
      name: 'Invoice, without invoice lines. Only description and total',
      languageCode: 'en',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '1BCD8B0C-4418-FA2B-6F3C-D84FE12FA1C1'
        : '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1C1',
    },
    {
      templateType: 2,
      name: 'Creditnota',
      languageCode: 'nl',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '1BCD8B0C-4418-FA2B-6F3C-D84FE12FA1D5'
        : '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1D5',
    },
    {
      templateType: 2,
      name: 'Note de crédit',
      languageCode: 'fr',
      documentId: '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1E5',
    },
    {
      templateType: 2,
      name: 'Credit note',
      languageCode: 'en',
      documentId: isDutchTenantConfiguration(dataCache.getArray('tenantConfiguration'))
        ? '1BCD8B0C-4418-FA2B-6F3C-D84FE12FA1C5'
        : '1BCD8B0C-4418-4E72-6F3C-D84FE12FA1C5',
    },
  ];

  var initialize = () => {
    vm.exampleTemplatesCollapsed = localStorageService.get(CollapsedStorageKey) || false;
    vm.languageCode = $translate.use().split('-')[0];
    vm.languages = vm.languages.sort(languageSorterCurrentFirst(vm.languageCode));

    vm.invoiceSampleTemplates = vm.sampleTemplates.filter(
      x => x.languageCode == vm.languageCode && x.templateType == 0,
    );
    vm.creditNoteSampleTemplates = vm.sampleTemplates.filter(
      x => x.languageCode == vm.languageCode && x.templateType == 2,
    );

    vm.templateTypes = vm.templateTypes
      .map(x => ({
        ...x,
        label: translateListFilter(x.key, 'templateType', x.value),
      }))
      .sort(dynamicSort('label'));

    // if the tenant was created after the release of 29/04/2021, he will be using the {moustache} syntax of the invoice fields
    // tenants created before that date, will be using the merge field syntax.
    var filename = `AdminPulse-invoice-template-fields.docx`;
    let createdOn = dataCache.getArray('createdOn');
    vm.showActionSpinner = false;
    vm.isLoading = false;
    if (createdOn) {
      var releaseDate = moment('29-04-2021', 'DD-MM-YYYY');
      if (moment.utc(createdOn).isAfter(releaseDate)) {
        vm.showEditTemplate = false;
        if (dataCacheService.hasUserConnectPlatform(ConnectPlatform.O365Editor)) {
          vm.showEditTemplate = true;
        }
      }
    }
  };
  initialize();

  var deregistration = $rootScope.$on('$translateChangeSuccess', initialize);
  $scope.$on('$destroy', deregistration);

  var initFilters = () => {
    const filtersInStorage = JSON.parse(sessionStorage.getItem(SessionStorageKey)) || {};
    let {
      templateType = null,
      languageCode = null,
      companyId = null,
      active = false,
    } = filtersInStorage;
    vm.templateType = templateType;
    vm.company = vm.companies.find(x => x.id === companyId);
    vm.language = languageCode;
    vm.activeOnly = active;
    if (vm.table && filtersInStorage !== {}) {
      const tableFilters = Object.keys(filtersInStorage).reduce((result, key) => {
        const value = filtersInStorage[key];
        if (value === null) return result;
        result[key] = { items: [value] };
        return result;
      }, {});
      vm.table.initializeParams({ filter: tableFilters });
    }
  };

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };

  vm.collapseExamples = () => {
    vm.exampleTemplatesCollapsed = !vm.exampleTemplatesCollapsed;
    localStorageService.set(CollapsedStorageKey, vm.exampleTemplatesCollapsed);
  };
  vm.collapseCompanyTemplateOverview = () => {
    vm.companyTemplateOverviewCollapsed = !vm.companyTemplateOverviewCollapsed;
  };

  enumCacheSvc.get('templateType').then(function(data) {
    // Filter out invoce / invoicedetail / creditnote templatetypes
    vm.templateTypes = data
      .filter(x => invoiceTemplateTypes.indexOf(x.key) >= 0)
      .map(x => ({
        ...x,
        label: translateListFilter(x.key, 'templateType', x.value),
      }))
      .sort(dynamicSort('label'));
  });

  var mapTemplate = function(template) {
    return {
      ...template,
      company: vm.companies.find(x => x.id === template.companyId),
    };
  };

  vm.editTemplate = template => {
    DocumentService.edit(template.documentId, vm.languageCode);
  };

  var loadTemplateCheckoutInfo = () => {
    const templateIds = vm.invoiceTemplates.map(t => t.documentId);
    DocumentService.getTemplateCheckoutInfo(templateIds).then(data => {
      vm.templateCheckoutInfo = data;
    });
  };

  vm.retrieveDocumentTemplates = function() {
    $http.post(appUrls.api + '/api/documentTemplate/templates', invoiceTemplateTypes).then(
      function(result) {
        if (result && result.data) {
          vm.invoiceTemplates = result.data.map(mapTemplate);
          loadTemplateCheckoutInfo();
          initFilters();
          vm.refreshCompanyTemplateOverview();
        }
      },
      function(error) {
        showError(error);
      },
    );
  };
  vm.retrieveDocumentTemplates();

  vm.downloadTemplate = function(invoiceTemplate) {
    if (!invoiceTemplate.documentId) return;

    invoiceTemplate.downloading = true;

    DocumentService.download(invoiceTemplate.documentId).then(
      () => {
        $timeout(function() {
          invoiceTemplate.downloading = false;
        }, 0);
      },
      () => {
        $timeout(function() {
          invoiceTemplate.downloading = false;
        }, 0);
      },
    );
  };

  vm.activateTemplate = function(invoiceTemplate) {
    if (!invoiceTemplate) return;

    var companyTemplates = invoiceTemplate.companyId
      ? []
      : vm.invoiceTemplates.filter(
          t =>
            t.active &&
            t.companyId &&
            t.languageCode === invoiceTemplate.languageCode &&
            t.templateType === invoiceTemplate.templateType,
        );
    if (!companyTemplates.length) {
      activateTemplate(invoiceTemplate, false);
      return;
    }

    dialogsSvc
      .showYesNoCancelList(
        'msgConfirmActivateTemplateAllCompaniesTitle',
        'msgConfirmActivateTemplateAllCompanies',
        companyTemplates.map(t => (t.company ? t.company.name + ': ' : '') + t.name),
      )
      .then(includeCompanyTemplates => {
        if (includeCompanyTemplates === null) return; // cancel
        activateTemplate(invoiceTemplate, includeCompanyTemplates);
      });
  };

  function activateTemplate(invoiceTemplate, includeCompanyTemplates) {
    invoiceTemplate.activating = true;

    $http
      .post(appUrls.api + '/api/documentTemplate/activate/' + invoiceTemplate.id, null, {
        params: { includeCompanyTemplates: includeCompanyTemplates },
      })
      .then(
        function(result) {
          invoiceTemplate.activating = false;
          if (result && result.data) {
            flySvc.success('msgConfirmChange');
            var activationResult = result.data;
            if (activationResult.activatedDocumentTemplate) {
              var activatedTemplate = vm.invoiceTemplates.find(
                x => x.id === activationResult.activatedDocumentTemplate.id,
              );
              if (activatedTemplate) {
                angular.extend(activatedTemplate, activationResult.activatedDocumentTemplate);
              }
            }
            (activationResult.deactivatedDocumentTemplates || []).forEach(deactivated => {
              var deactivatedTemplate = vm.invoiceTemplates.find(x => x.id === deactivated.id);
              if (deactivatedTemplate) {
                angular.extend(deactivatedTemplate, deactivated);
              }
            });
            vm.refreshCompanyTemplateOverview();
          }
        },
        function(error) {
          invoiceTemplate.activating = false;
          showError(error);
        },
      );
  }

  vm.submit = function(invoiceTemplate, value, field) {
    if (angular.equals(invoiceTemplate[field], value)) return false;

    var model = angular.copy(invoiceTemplate);
    model[field] = value;

    return $http.put(appUrls.api + '/api/documentTemplate/UpdateTemplate', model).then(
      function({ data }) {
        if (data) {
          flySvc.success('msgConfirmChange');
          angular.extend(invoiceTemplate, mapTemplate(data));
          vm.refreshCompanyTemplateOverview();
          return false;
        }
        return '';
      },
      function(error) {
        showError(error);
        return '';
      },
    );
  };

  vm.previewTemplate = function(invoiceTemplate) {
    ModalService.showModal({
      template: require('./dialogs/previewInvoiceTemplateDialog.html'),
      controller: 'PreviewInvoiceTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        documentTemplateId: invoiceTemplate.id,
        documentUrl: null,
        sampleTemplateId: null,
        sampleTemplateType: invoiceTemplate.templateType,
      },
    }).then(function(modal) {
      modal.element.modal();
    });
  };

  vm.previewExample = function(documentUrl) {
    ModalService.showModal({
      template: require('./dialogs/previewInvoiceTemplateDialog.html'),
      controller: 'PreviewInvoiceTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        documentTemplateId: null,
        documentUrl: documentUrl,
        sampleTemplateId: null,
        sampleTemplateType: null,
      },
    }).then(function(modal) {
      modal.element.modal();
    });
  };

  vm.previewSample = function(templateId, templateType) {
    ModalService.showModal({
      template: require('./dialogs/previewInvoiceTemplateDialog.html'),
      controller: 'PreviewInvoiceTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        documentTemplateId: null,
        documentUrl: null,
        sampleTemplateId: templateId,
        sampleTemplateType: templateType,
      },
    }).then(function(modal) {
      modal.element.modal();
    });
  };

  vm.add = function() {
    ModalService.showModal({
      template: require('./dialogs/addInvoiceTemplateDialog.html'),
      controller: 'AddInvoiceTemplateDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        companyId: vm.company?.id,
        templateTypes: vm.templateTypes,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
      modal.close.then(function(invoiceTemplate) {
        if (!invoiceTemplate) return;
        vm.invoiceTemplates.push(mapTemplate(invoiceTemplate));
        flySvc.success('msgConfirmAddInvoiceTemplate');
        vm.refreshCompanyTemplateOverview();
      });
    });
  };

  vm.delete = function(invoiceTemplate) {
    if (!invoiceTemplate.id) return false;

    return dialogsSvc.showYesNo('comfirmDeleteTitle', 'msgConfirmDeleteInvoiceTemplate').then(
      function(result) {
        invoiceTemplate.deleting = true;
        $http.delete(appUrls.api + '/api/documentTemplate/delete/' + invoiceTemplate.id).then(
          function() {
            flySvc.success('msgConfirmChange');
            invoiceTemplate.deleting = false;
            var idx = vm.invoiceTemplates.indexOf(invoiceTemplate);
            if (idx >= 0) vm.invoiceTemplates.splice(idx, 1);
            vm.refreshCompanyTemplateOverview();
          },
          function(error) {
            invoiceTemplate.deleting = false;
            showError(error);
            return false;
          },
        );
        return true;
      },
      function() {
        return false;
      },
    );
  };

  vm.replaceTemplate = function(files, item) {
    if (!files || files.length < 1) return;

    var data = new FormData();
    data.append('data', files[0].data);

    item.replacing = true;

    $http({
      method: 'post',
      url: appUrls.api + '/api/documentTemplate/ReplaceTemplate/' + item.id,
      headers: {
        'Content-Type': undefined,
      },
      data: data,
    })
      .then(function({ data }) {
        item.replacing = false;
        if (!data) return;
        angular.extend(item, data);
        flySvc.success('msgConfirmChange');
      })
      .catch(function({ data }) {
        item.replacing = false;
        flySvc.error(data);
      });
  };

  vm.openDocumentation = function() {
    const zendeskArticleId = '21096405109532';
    const url = getZendeskUrl(zendeskArticleId, $translate.use());
    $window.open(url, '_blank');
  };

  vm.downloadSample = function(sample) {
    const endpoint = appUrls.api + '/api/documentTemplate/DownloadSample/' + sample.documentId;
    $http
      .get(endpoint, {
        responseType: 'arraybuffer',
      })
      .then(
        result => {
          const contentDisposition = result.headers('Content-Disposition');
          const filename = `${sample.name}.docx`;
          var fileType = result.headers('Content-Type');

          var blob = new Blob([result.data], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessing',
          });
          if (blob) {
            FileSaver.saveAs(blob, filename);
          }
        },
        error => {
          showArrayBufferError(error);
        },
      );
  };
  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      console.error(ex);
      //Parsing error?
      flySvc.error();
    }
  };
  vm.filter = function(column, value) {
    let filters = JSON.parse(sessionStorage.getItem(SessionStorageKey)) || {};

    if (value === null || value === '') {
      vm.table.clearFilter(column);
      delete filters[column];
    } else {
      vm.table.setFilter(column, { items: [value] });
      filters = { ...filters, [column]: value };
    }
    sessionStorage.setItem(SessionStorageKey, JSON.stringify(filters));
  };
  vm.filterCompany = function(selectedCompany) {
    const companyId = selectedCompany?.id;
    let filters = JSON.parse(sessionStorage.getItem(SessionStorageKey)) || {};

    if (!companyId) {
      vm.table.clearFilter('companyId');
      delete filters['companyId'];
    } else {
      vm.table.setFilter('companyId', { items: [companyId, null] });
      filters = { ...filters, companyId: companyId };
    }
    sessionStorage.setItem(SessionStorageKey, JSON.stringify(filters));
  };

  vm.copyTemplate = function(item) {
    var formData = new FormData();
    formData.append('id', item.id);

    $http({
      method: 'post',
      url: appUrls.api + '/api/documentTemplate/Copy/' + item.id,
      headers: {
        'Content-Type': undefined,
      },
      data: formData,
    })
      .then(function(response) {
        var copiedTemplate = response.data;

        if (copiedTemplate) {
          vm.invoiceTemplates.push(mapTemplate(copiedTemplate));
          flySvc.success('msgConfirmChange');
        } else {
          console.error('Copied template data not received.');
        }
      })
      .catch(function(error) {
        console.error('Error copying template:', error);
        flySvc.error(error.data && error.data.code, error.data && error.data.parameters);
      });
  };

  vm.isCheckedOut = documentId => {
    return vm.templateCheckoutInfo && vm.templateCheckoutInfo[documentId];
  };

  vm.isCheckedOutByCurrentUser = documentId => {
    return (
      vm.templateCheckoutInfo &&
      vm.templateCheckoutInfo[documentId] &&
      vm.templateCheckoutInfo[documentId] === AuthService.getUserId()
    );
  };

  vm.canDiscardCheckout = function() {
    return AuthService.hasPermission({ functionality: 'CompanyOwn', privilege: 'Update' });
  };

  vm.checkinDocument = function(item) {
    if (vm.isCheckedOutByCurrentUser(item.documentId)) {
      checkin(item);
    }
  };

  vm.onDiscardCheckout = function(item) {
    dialogsSvc
      .showYesNo('comfirmTitle', 'msgDiscardCheckout', {
        name: dataCacheService.getUserName(vm.templateCheckoutInfo[item.documentId]),
      })
      .then(function() {
        discardCheckout(item);
      });
  };

  vm.openEdit = function(item) {
    DocumentService.getCheckedOutLink(item.documentId).then(link => {
      if (!link) return;
      window.open(link);
    });
  };

  const checkin = function(item) {
    vm.showActionSpinner = true;
    DocumentService.checkin(item.documentId).then(
      () => {
        flySvc.success();
        vm.showActionSpinner = false;
        vm.templateCheckoutInfo[item.documentId] = null;
      },
      error => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.code) {
          flySvc.error(error);
        } else {
          flySvc.success();
        }
        log.error('error checking in document ', error);
        vm.showActionSpinner = false;
      },
    );
  };

  const discardCheckout = function(item) {
    vm.showActionSpinner = true;
    DocumentService.discardCheckout(item.documentId).then(
      () => {
        flySvc.success();
        vm.showActionSpinner = false;
        loadTemplateCheckoutInfo();
      },
      error => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.code) {
          flySvc.error(error);
          vm.showActionSpinner = false;
        } else {
          flySvc.success();
        }
        log.error('error discarding checkout ', error);
      },
    );
  };

  vm.checkoutDocument = function(item, openinApp) {
    vm.showActionSpinner = true;
    DocumentService.checkout(item.documentId, openinApp).then(
      data => {
        if (!!data) {
          flySvc.success();
          loadTemplateCheckoutInfo();
        }
        vm.showActionSpinner = false;
      },
      error => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.code) {
          flySvc.error(error);
          vm.showActionSpinner = false;
        } else {
          flySvc.success();
        }
        log.error('error checking out document ', error);
      },
    );
  };

  vm.getDisabledStyles = function() {
    if (vm.showActionSpinner || vm.isLoading) {
      return {
        'pointer-events': 'none',
        color: '#ccc',
      };
    }
    return {};
  };

  vm.getTemplate = (companyId, languageCode, templateType) => {
    return vm.invoiceTemplates.find(
      t =>
        t.companyId === companyId &&
        t.languageCode === languageCode &&
        t.templateType === templateType &&
        !!t.active,
    );
  };
  vm.refreshCompanyTemplateOverview = function() {
    // A single company tenant can still own company bound templates; show the column so they can be fixed.
    // Once shown, keep it so the editable cell is not destroyed while its save is being processed.
    vm.showCompanyColumn = vm.showCompanyColumn || vm.invoiceTemplates.some(t => !!t.companyId);
    if (!vm.multipleCompanies) return;
    vm.companyTemplateOverviewProblem = false;
    vm.companyTemplateOverview = vm.companies.map(c => {
      const company = {
        id: c.id,
        name: c.name,
        templates: vm.templateTypes
          .map(tt => {
            let isFallback = true;
            let hasProblem = false;

            return {
              label: tt.label,
              templateType: tt.key,
              ...vm.languages.reduce((result, language) => {
                let template =
                  vm.getTemplate(c.id, language.code, tt.key) ??
                  vm.getTemplate(null, language.code, tt.key);
                if (template != null) {
                  result[language.code] = template;
                  isFallback = false;
                  return result;
                }

                const fallback = invoiceTemplateTypesFallbacks[tt.key];
                if (fallback !== null) {
                  template =
                    vm.getTemplate(c.id, language.code, fallback) ??
                    vm.getTemplate(null, language.code, fallback);
                }

                if (!template) {
                  vm.companyTemplateOverviewProblem = true;
                  hasProblem = true;
                }
                result[language.code] = template;
                return result;
              }, {}),
              isFallback,
              hasProblem,
            };
          })
          .filter(x => !x.isFallback || x.hasProblem),
      };
      return company;
    });
  };
}
